import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-download",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
		/* @__PURE__ */ _jsx("polyline", { points: "7 10 12 15 17 10" }),
		/* @__PURE__ */ _jsx("line", {
			x1: 12,
			x2: 12,
			y1: 15,
			y2: 3
		})
	]
});
export default SvgDownload;
